function CitationLabel({ children }) {
  const label =
    typeof children === 'string'
      ? children.trim().replace(/[:：]\s*$/, '')
      : children;

  return (
    <>
      <strong>{label}:</strong>
      <br />
    </>
  );
}

export default CitationLabel;
